import React, { useEffect, useState } from "react";
import mime from "mime";
import { downloadErrorResultFile } from "../services/errorResultService";
import Loading from "../../../components/Shared/Loading";
import FileViewer from "../../../components/Shared/FileViewer";

import "./error-preview.css";

const ErrorPreviewComponent = ({ fileName, aiOcr }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setError(null);
      setFile(null);

      let downloadFileName = fileName;
      if (
        fileName.toLowerCase().endsWith(".docx") ||
        fileName.toLowerCase().endsWith(".rtf") ||
        fileName.toLowerCase().endsWith(".doc")
      ) {
        downloadFileName =
          fileName.substring(0, fileName.length - fileName.split(".")[fileName.split(".").length - 1].length) + "pdf";
      }

      const { data, error: downloadError } = await downloadErrorResultFile(downloadFileName, aiOcr);
      if (downloadError) {
        setError(downloadError.status === 404 ? new Error("The file doesn't exist") : downloadError);
        setFile(null);
        setIsLoading(false);
        return;
      }
      const mimeType = mime.getType(downloadFileName);

      setFile({ data, mimeType });
      setIsLoading(false);
    })();
  }, [fileName, aiOcr]);

  return (
    <div style={{ overflowY: "scroll", height: "calc(100vh - 180px)" }}>
      {isLoading && <Loading />}
      {error && <p className="has-text-danger">{error.message}</p>}
      {file && <FileViewer key={Math.random()} data={file.data} mimeType={file.mimeType} />}
    </div>
  );
};

export default ErrorPreviewComponent;
